import React from "react";
import PageFrame from "./PageFrame";

export default function MatchmakerPage({ matchmaker, pageNum, totalPages }) {
    return (
        <PageFrame pageNum={pageNum} totalPages={totalPages} label="Decision Guide">
            <div className="max-w-5xl mx-auto px-6 sm:px-10 lg:px-16 py-16 sm:py-24 w-full">
                <div className="eyebrow">Your Decision Guide</div>
                <h2 className="serif-display text-5xl sm:text-6xl text-navy mt-4 mb-4">
                    Which city is right for you?
                </h2>
                <p className="text-muted2 max-w-2xl mb-12 leading-relaxed text-lg">
                    Match your priorities to the community that fits. The Emerald Coast has a place for every life — here's the shortcut.
                </p>

                <div className="border border-hairline divide-y divide-hairline bg-white">
                    {matchmaker.map((m, i) => (
                        <MatchRow key={m.profile} profile={m.profile} city={m.city} index={i} />
                    ))}
                </div>
            </div>
        </PageFrame>
    );
}

function MatchRow({ profile, city, index }) {
    const number = String(index + 1).padStart(2, "0");
    return (
        <div className="grid grid-cols-1 md:grid-cols-12 gap-3 p-6 hover:bg-sand/50 transition-colors">
            <div className="md:col-span-8 flex items-start gap-4">
                <div className="serif-display text-2xl text-coral mt-0.5 w-8 flex-shrink-0">
                    {number}
                </div>
                <div className="text-ink/90 text-lg leading-snug font-serif">
                    {profile}
                </div>
            </div>
            <div className="md:col-span-4 md:text-right">
                <span className="inline-block bg-navy text-cream font-sans text-xs tracking-[0.2em] uppercase px-4 py-2">
                    {city}
                </span>
            </div>
        </div>
    );
}
